import { render, staticRenderFns } from "./InputParcelType.vue?vue&type=template&id=c866df80"
import script from "./InputParcelType.vue?vue&type=script&lang=js"
export * from "./InputParcelType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports